import React, { useState } from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import "./PastEvents.scss";

import img57357 from "../Media/events/past/57357.jpg";
import imgAFL1 from "../Media/events/past/AFL-1.jpg";
import imgAFL2 from "../Media/events/past/AFL-2.jpg";
import imgAFL3 from "../Media/events/past/AFL-3.jpg";
import imgAFL4 from "../Media/events/past/AFL-4.jpg";
import imgAFL5 from "../Media/events/past/AFL-5.jpg";
import imgAFL6 from "../Media/events/past/AFL-6.jpg";
import imgAFL7 from "../Media/events/past/AFL-7.jpg";
import imgAmoun from "../Media/events/past/amoun.jpg";
import imgAttending from "../Media/events/past/attending.jpg";
import imgAudience from "../Media/events/past/audience.jpg";
import imgAusArtAuditorium from "../Media/events/past/aus-art-auditorium.jpg";
import imgAusArtFest from "../Media/events/past/aus-art-fest.jpg";
import imgAusEgCollab from "../Media/events/past/aus-eg-collab.jpg";
import imgAusEgTheatre from "../Media/events/past/aus-eg-theatre.jpg";
import imgAusFilm from "../Media/events/past/aus-film.jpg";
import imgBasira from "../Media/events/past/basira.jpg";
import imgBasira2 from "../Media/events/past/basira-2.jpg";
import imgCairoJazzFest from "../Media/events/past/cairo-jazz-fest.jpg";
import imgCairoJazz from "../Media/events/past/cairo-jazz.jpg";
import imgCanadianBusiness from "../Media/events/past/canadian-business.jpg";
import imgCU from "../Media/events/past/cu.jpg";
import imgCurrentAusAmb from "../Media/events/past/current-aus-amb.jpg";
import imgEdith from "../Media/events/past/edith.jpg";
import imgEgArtAus from "../Media/events/past/eg-art-aus.jpg";
import imgEgMediaAus from "../Media/events/past/eg-media-aus.jpg";
import imgEgMediaInd from "../Media/events/past/eg-media-ind.jpg";
import imgAusDay from "../Media/events/past/aus-day.jpg";
import imgEgyMedia from "../Media/events/past/egy-media.jpg";
import imgEmergingTalent from "../Media/events/past/emerging-talent.jpg";
import imgExtraCur from "../Media/events/past/extra-cur.jpg";
import imgFarewellAus from "../Media/events/past/farewell-aus.jpg";
import imgGallipoli from "../Media/events/past/gallipoli.jpg";
import imgGallipoli2 from "../Media/events/past/gallipoli-2.jpg";
import imgGallipoli3 from "../Media/events/past/gallipoli-3.jpg";
import imgHayat from "../Media/events/past/hayat.jpg";
import imgIndigenous from "../Media/events/past/indigenous.jpg";
import imgIndigenous2 from "../Media/events/past/indigenous-2.jpg";
import imgKyle from "../Media/events/past/kyle.jpg";
import imgMahoney from "../Media/events/past/mahoney.jpg";
import imgManufacturing from "../Media/events/past/manufacturing.jpg";
import imgMediaStudents from "../Media/events/past/media-students.jpg";
import imgMinImmigration from "../Media/events/past/min-immigration.jpg";
import imgNaidoc from "../Media/events/past/naidoc.jpg";
import imgNeil from "../Media/events/past/Neil.jpg";
import imgNZFilm from "../Media/events/past/nz-film.jpg";
import imgPanelGouna from "../Media/events/past/panel-gouna.jpg";
import imgPromotingAus from "../Media/events/past/promoting-aus.jpg";
import imgRehany from "../Media/events/past/rehany.jpg";
import imgRoger from "../Media/events/past/roger.jpg";
import imgSponsored from "../Media/events/past/sponsored.jpg";
import imgTen from "../Media/events/past/ten.jpg";
import imgTheatreClosing from "../Media/events/past/theatre-closing.jpg";
import imgWarMem1 from "../Media/events/past/war-mem-1.jpg";
import imgWarMem2 from "../Media/events/past/war-mem-2.jpg";

import imgChaplin2017 from "../Media/events/past2/chaplin-stage-2017.jpg";
import imgAuskick1 from "../Media/events/past2/auskick-egypt-1.jpg";
import imgAuskick2 from "../Media/events/past2/auskick-egypt-2.jpg";
import imgAuskick3 from "../Media/events/past2/auskick-egypt-3.jpg";
import imgAuskick4 from "../Media/events/past2/auskick-egypt-4.jpg";
import imgCrossCulturalPlay from "../Media/events/past2/cross-cultural-play-reading.jpg";
import imgMediaReporting1 from "../Media/events/past2/media-reporting-cooperation-1.jpg";
import imgMediaReporting2 from "../Media/events/past2/media-reporting-cooperation-2.jpg";
import imgCairoJazz2021 from "../Media/events/past2/cairo-jazz-festival-2021.jpg";
import imgMediaAwards2023 from "../Media/events/past2/media-awards-auc-2023.jpg";
import imgAUCStudents from "../Media/events/past2/auc-media-students.jpg";
import imgCollaborativeProject from "../Media/events/past2/collab-canberra-historian.jpg";
import imgWintershall2010_1 from "../Media/events/past2/wintershall-2010-1.jpg";
import imgWintershall2010_2 from "../Media/events/past2/wintershall-2010-2.jpg";
import imgWintershall2010_3 from "../Media/events/past2/wintershall-2010-3.jpg";
import imgAFLDonation from "../Media/events/past2/afl-ball-donation.jpg";
import imgAmbassadorMiles2018_1 from "../Media/events/past2/ambassador-miles-2018-1.jpg";
import imgAmbassadorMiles2018_2 from "../Media/events/past2/ambassador-miles-2018-2.jpg";
import imgAmbassadorMiles2018_3 from "../Media/events/past2/ambassador-miles-2018-3.jpg";
import imgOnlineExhibition2021 from "../Media/events/past2/online-arts-exhibition-2021.jpg";
import imgAwardWinningStudents2023 from "../Media/events/past2/auc-award-winning-students-2023.jpg";

import imgAustralianEmbassyBook from "../Media/events/upcoming/austrailian-embassy-book.jpg";
import imgOud from "../Media/oud.jpg";
import imgKyleUpcoming from "../Media/events/upcoming/kyle.jpg";

const events = [
  { date: "April 25, 2025", description: "Recruitment of Australians and Egyptians in the Great War: a conversation with author and historian Kyle Anderson at the Egyptian Embassy in Canberra, on the Referendum and the Egyptian Labour Corps", images: [imgKyleUpcoming] },
  { date: "December 21, 2024", description: "Joseph Tawadros: A Night of Oud, Australian Oud virtuoso Joseph Tawadros alongside the Alexandrian String Orchestra and Cuban conductor Veronica Bievs, in the Grand Hall of the Alexandria Library", images: [imgOud] },
  { date: "", description: "Australian Embassy Book Donations: with the assistance of ANZEG, the Australian Embassy in Cairo donated Australian books about art, culture and science to the library at the American University in Cairo", images: [imgAustralianEmbassyBook] },
  { date: "2020", description: "Collaboration between Australia and Egypt organised by ANZEG during Covid-19", images: [imgAusEgCollab] },
  { date: "2018", description: "ANZEG participating in university collaborations organised by the Ministry & Canadian Business Council", images: [imgCanadianBusiness] },
  { date: "2018", description: "Cairo University events", images: [imgCU] },
  { date: "", description: "Co Chair leading a group of Egyptian administration professionals at a manufacturing plant in Cairo", images: [imgManufacturing] },
  { date: "", description: "Egyptian media reporting on ANZEG's cultural exchange programs with Australia", images: [imgEgyMedia] },
  { date: "2021", description: "The Australian Film & Television Academy workshop with CEO John Orscik", images: [imgAusFilm] },
  { date: "2018", description: "Egyptian media reporting on Australian artists coming to Egypt in a cultural exchange program with the Egyptian Ministry of Culture", images: [imgEgMediaAus] },
  { date: "2018", description: "Egyptian media reporting on indigenous Australian art in Egypt, hosted by Co Chair and the Australian Embassy", images: [imgEgMediaInd] },
  { date: "2017", description: "Media students with Co Chair", images: [imgMediaStudents] },
  { date: "2018", description: "Co Chair with former Australian Ambassador to Egypt Neil Hawkins and current Australian Ambassador to Colombia Anna Chrisp", images: [imgNeil] },
  { date: "2018", description: "Initiation of the Australian Cultural Program in Cairo at the famous El Rehany Theatre", images: [imgRehany] },
  { date: "", description: "Sponsored by the AFL & the Australian Embassy in Cairo", images: [imgSponsored] },
  { date: "2018", description: "Australian Football program in Egypt, supported by the AFL and the Australian Embassy in Cairo", images: [imgAFL1, imgAFL2, imgAFL3, imgAFL4, imgAFL5, imgAFL6, imgAFL7] },
  { date: "2024", description: "Australia Day celebrations at the Australian Embassy in Cairo with Australian Ambassador Dr Axel Wabenhorst", images: [imgAusDay] },
  { date: "2018", description: "ANZEG participating in organising Australian artists at the Cairo University Auditorium", images: [imgAusArtAuditorium] },
  { date: "2018", description: "Attending the festival of Drama & Cinema", images: [imgAttending] },
  { date: "2021", description: "Co Chair directing the Cairo Jazz Festival's video production", images: [imgCairoJazz] },
  { date: "2021", description: "Cairo Jazz Festival", images: [imgCairoJazzFest] },
  { date: "2022", description: "Co Chair farewelling the former Australian Ambassador Glenn Miles in Cairo", images: [imgFarewellAus] },
  { date: "2015", description: "Leadership & communications courses with Amoun Pharma Egypt", images: [imgAmoun] },
  { date: "2018", description: "NAIDOC Week with the Australian Embassy & Australia Council Chair, led by ANZEG's Co Chair", images: [imgNaidoc] },
  { date: "2018", description: "ANZEG promoting and bringing over Australian artists to Egypt at the University Theatre Festival", images: [imgPromotingAus] },
  { date: "2018", description: "ANZEG helping Australian artists join the festival in Egypt", images: [imgAusArtFest] },
  { date: "2018", description: "Australian artist Mahoney Keily in Egypt to facilitate workshops for students", images: [imgMahoney] },
  { date: "2022", description: "Co Chair aided in connecting Egyptian artist Hayat Selim with practitioners in Canberra, Australia, for a lecture at the ANU", images: [imgHayat] },
  { date: "", description: "Co Chair welcoming the current Australian Ambassador Dr Axel Wabenhorst to Cairo", images: [imgCurrentAusAmb] },
  { date: "", description: "Egyptian audience enjoying cultural events produced by ANZEG", images: [imgAudience] },
  { date: "2023", description: "ANZEG helping emerging talent in Cairo with production assistance", images: [imgEmergingTalent] },
  { date: "2024", description: "Co Chair commemorating the ANZACs at the War Memorial in Cairo", images: [imgWarMem1, imgWarMem2] },
  { date: "2024", description: "Gallipoli play performed in Melbourne, Australia, as part of ANZEG's cultural program", images: [imgGallipoli, imgGallipoli2] },
  { date: "2024", description: "Author & historian Kyle Anderson visits Egypt to discuss his new book on Egypt's involvement in WW1", images: [imgKyle] },
  { date: "2024", description: "Cultural work between Australia and Egypt with legendary Australian actor Roger Ward and the crew of the Gallipoli play", images: [imgRoger, imgGallipoli3] },
  { date: "2018", description: "Production for Basira Information's company on the importance of transparency in Egypt, directed by Co Chair", images: [imgBasira, imgBasira2] },
  { date: "2019", description: "Extra-curricular activities between Egypt and Australia in Cairo", images: [imgExtraCur] },
  { date: "2019", description: "Co Chair attending panel discussions at El Gouna Film Festival", images: [imgPanelGouna] },
  { date: "2019", description: "Co Chair organised New Zealand filmmaker Jan Sandle to attend the British University Film Festival as a panel member", images: [imgNZFilm] },
  { date: "2023", description: "Egyptian artist in Australia speaking with the Australian Broadcasting Corporation as part of her trip and work with Theatre Projects Canberra", images: [imgEgArtAus] },
  { date: "2018", description: "Closing ceremony of the Theatre Festival", images: [imgTheatreClosing] },
  { date: "2016", description: "Australian-Egyptian art and theatre collaboration directed by Co Chair", images: [imgAusEgTheatre] },
  { date: "2016", description: "Co Chair at the 57357 Hospital for Children with Cancer in Cairo, donating his time for vocal training with staff", images: [img57357] },
  { date: "2018", description: "Indigenous artist and Chair of the Australia Council Lee-Ann Buckskin in talks with Co Chair and the Australian Embassy", images: [imgIndigenous, imgIndigenous2] },
  { date: "2020", description: "Co Chair discussing possible English media programs with Ten Media Egypt", images: [imgTen] },
  { date: "2019", description: "Visit from the Minister of Immigration, involved in a business delegation to Australia", images: [imgMinImmigration] },
  { date: "2019", description: "Co Chair with the Dean and administration staff from Edith Cowan University, Perth, discussing the first Australian university in Egypt", images: [imgEdith] },
  { date: "2017", description: "ANZEG production of Chaplin on stage", images: [imgChaplin2017] },
  { date: "", description: "Auskick in rural Egypt, free for Egyptian children", images: [imgAuskick1, imgAuskick2, imgAuskick3, imgAuskick4] },
  { date: "", description: "Australia-Egypt cross-cultural readings of an Australian play", images: [imgCrossCulturalPlay] },
  { date: "", description: "Australian media reporting on Australia-Egypt cultural cooperation", images: [imgMediaReporting1, imgMediaReporting2] },
  { date: "2021", description: "Cairo Jazz Festival", images: [imgCairoJazz2021] },
  { date: "2023", description: "Co Chair attending media awards at the American University in Cairo", images: [imgMediaAwards2023] },
  { date: "", description: "Co Chair with students from the American University in Cairo in media studies", images: [imgAUCStudents] },
  { date: "", description: "Collaborative project with Australia-Canberra and Egypt historian Ian Batterham and Co Chair", images: [imgCollaborativeProject] },
  { date: "2010", description: "Communications and leadership courses by Co Chair at Wintershall Petroleum", images: [imgWintershall2010_1, imgWintershall2010_2, imgWintershall2010_3] },
  { date: "2017-2018", description: "Donation of AFL balls from the Australian Embassy in Cairo", images: [imgAFLDonation] },
  { date: "2018", description: "Former Australian Ambassador Glenn Miles with Egyptian participants", images: [imgAmbassadorMiles2018_1, imgAmbassadorMiles2018_2, imgAmbassadorMiles2018_3] },
  { date: "2021", description: "Online arts exhibition featuring Australia, Holland, and the UK", images: [imgOnlineExhibition2021] },
  { date: "2023", description: "With award-winning students from the American University in Cairo", images: [imgAwardWinningStudents2023] },
];

const PastEvents = () => {
  const [popup, setPopup] = useState({ open: false, images: [] });

  return (
    <>
      <NavBar />
      <main className="pastEvents">
        <header className="pastEvents__hero">
          <div className="container">
            <span className="eyebrow">Events</span>
            <h1 className="section-heading">Past Events</h1>
            <p className="lede">
              Relive some of our most memorable moments. Explore the
              highlights from past events that celebrated community,
              culture, and collaboration.
            </p>
          </div>
        </header>

        <section className="pastEvents__grid">
          <div className="container pastEvents__gridInner">
            {events.map((event, index) => (
              <button
                type="button"
                className="pastEvents__card"
                key={index}
                onClick={() => setPopup({ open: true, images: event.images })}
              >
                <div className="pastEvents__cardImage">
                  <img src={event.images[0]} alt={event.description} loading="lazy" />
                  {event.images.length > 1 && (
                    <span className="badge pastEvents__count">+{event.images.length - 1}</span>
                  )}
                </div>
                <div className="pastEvents__cardInfo">
                  <p>{event.description}</p>
                  {event.date && <span className="eyebrow">{event.date}</span>}
                </div>
              </button>
            ))}
          </div>
        </section>

        {popup.open && (
          <div className="pastEvents__popup" onClick={() => setPopup({ open: false, images: [] })}>
            <button
              type="button"
              className="pastEvents__popupClose"
              onClick={() => setPopup({ open: false, images: [] })}
              aria-label="Close"
            >
              &times;
            </button>
            <div className="pastEvents__popupImages" onClick={(e) => e.stopPropagation()}>
              {popup.images.map((image, idx) => (
                <img key={idx} src={image} alt={`Event detail ${idx + 1}`} />
              ))}
            </div>
          </div>
        )}
      </main>
      <Footer />
    </>
  );
};

export default PastEvents;
